import { MDBInput, MDBSelect } from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import { getMisc } from "../apiclients/streamsapi_bridge";
import { useTranslation } from "react-i18next";

function FaxGroupGeneralSettings({ register, errors, watch, setValue }) {
  const [locationList, setLocationList] = useState([]);
  const { t, i18n } = useTranslation();
  const [billingGroupList, setBillingGroupList] = useState([]);
  useEffect(() => {
    getAllLocations();
  }, []);

  async function getAllLocations() {
    let updates = {};
    console.log(sessionStorage.getItem("admin_session"));
    updates = {
      misc: ["all_locations", "billinggroups"],
    };

    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      updates
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const basicInfo = await response.json();
    if (!basicInfo) {
      const message = `An error has occured: ${response}`;
      return;
    }
    console.log("response data is :::::::::: " + JSON.stringify(basicInfo));
    setLocationList(
      (basicInfo.misc.all_locations ?? []).map((item) => ({
        text: item.loc_name,
        value: parseInt(item.loc_id, 10),
      }))
    );
    setBillingGroupList(
      (basicInfo.misc.billinggroups ?? []).map((item) => ({
        text: item.groupname,
        value: parseInt(item.groupid, 10), // Ensure id is a number
      }))
    );
  }

  return (
    <>
      <div className="general-settings">General</div>

      <div class="add-numbermain">
        <div class="tel-numbers">Name</div>
        <div class="d-flex w-30">
          <div class="phoneselect w-100">
            <MDBInput
              class="form-control"
              maxLength={20}
              name="groupName"
              {...register("name", { required: "Name is required" })}
            />
            {errors.name && (
              <p className="text-danger">{errors.name.message}</p>
            )}
          </div>
        </div>
      </div>

      {/* <div class="add-numbermain">
        <div class="tel-numbers">Email</div>
        <div class="d-flex w-30">
          <div class="phoneselect w-100">
            <MDBInput
              class="form-control"
              name="groupName"
              {...register("mailid", {
                required: "Email is required",
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: "Invalid Email ID",
                },
              })}
            />
            {errors.mailid && (
              <p className="text-danger">{errors.mailid.message}</p>
            )}
          </div>
        </div>
      </div>

      <div class="add-numbermain">
        <div class="tel-numbers">Retries</div>
        <div class="d-flex w-30">
          <div class="phoneselect w-100">
            <select
              className="form-control form-select w-100"
              {...register("retries", { setValueAs: (value) => Number(value) })}
            >
              {Array.from({ length: 20 }, (_, i) => (
                <option key={i + 1} value={i + 1}>
                  {i + 1}
                </option>
              ))}
            </select>
            {errors.retries && (
              <p className="text-danger">{errors.retries.message}</p>
            )}
          </div>
        </div>
      </div> */}
      <div className="add-numbermain">
        <div className="tel-numbers">{t("location")}</div>
        <div className="d-flex w-30">
          <div className="phoneselect w-100">
            <MDBSelect
              className="w-100"
              name="San Jose"
              search
              data={locationList}
              value={parseInt(watch("loc_id"))}
              onChange={(e) => {
                if (e && e.value) {
                  setValue("loc_id", parseInt(e.value), {
                    shouldDirty: true,
                  });
                }
              }}
            />
          </div>
        </div>
      </div>
      <div className="add-numbermain">
        <div className="tel-numbers">{t("Billing Group")}</div>
        <div className="d-flex w-30">
          <div className="phoneselect w-100">
            <MDBSelect
              className="w-100"
              name="San Jose"
              search
              data={billingGroupList}
              value={parseInt(watch("billing_grp"))}
              onChange={(e) => {
                if (e && e.value) {
                  setValue("billing_grp", parseInt(e.value), {
                    shouldDirty: true,
                  });
                }
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default FaxGroupGeneralSettings;
